import { cellRenderParseData } from '../../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'cuttingIncomingDate',
    caption: 'Дата фактич. отправки подкроя в SAP',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'cuttingBatchId',
    caption: 'Партия SAP подкроя',
    dataType: 'string'
  },
  {
    dataField: 'cuttingActualPieceId',
    caption: 'Номер подкройной полосы',
    dataType: 'string'
  },
  {
    dataField: 'cuttingPsStatusName',
    caption: 'Статус подкройной полосы',
    dataType: 'string'
  },
  {
    dataField: 'cuttingQuantity',
    caption: 'Фактическое кол-во подкройной полосы',
    dataType: 'number'
  },
  {
    dataField: 'cuttingThick',
    caption: 'Толщина',
    dataType: 'string'
  },
  {
    dataField: 'cuttingWidth',
    caption: 'Ширина',
    dataType: 'string'
  },
  {
    dataField: 'cuttingMark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'qcId',
    caption: 'CK(ПФ)',
    dataType: 'number'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК (ПФ)',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во, ост.',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'cuttingWeightOff',
    caption: 'Кол-во списания ПФ',
    dataType: 'number'
  },
  {
    dataField: 'cuttingMessageId',
    caption: '№ сообщения в SAP',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  }
];

export default columnDataGrid;
